import { Head } from "@inertiajs/react"

import AnnouncementForm from "@/components/announcements/announcement-form"
import AppLayout from "@/layouts/app-layout"

interface Image {
  id: number | string
  url: string
}
interface Video {
  id: number | string
  url: string
}
interface Announcement {
  id: number
  content: string
  content_text?: string
  status: "published" | "draft"
  images?: Image[]
  video_url?: string | null
  videos?: Video[]
  neighborhood?: { id: number; name: string } | null
}

interface Props {
  announcement: Announcement
}

export default function Edit({ announcement }: Props) {
  return (
    <AppLayout title="Editar Anuncio">
      <Head title="Editar Anuncio" />
      <div className="mx-auto max-w-6xl p-4 md:p-6">
        <AnnouncementForm
          title="Editar anuncio"
          initial={{
            id: announcement.id,
            content: announcement.content,
            content_text: announcement.content_text,
            status: announcement.status,
            images: announcement.images,
            video_url: announcement.video_url ?? null,
            videos: announcement.videos ?? [],
            neighborhood: announcement.neighborhood ?? null,
          }}
          submitPath={`/anuncios/${announcement.id}`}
          method="put"
        />
      </div>
    </AppLayout>
  )
}
